// 建議提問改由後台維護（#1365）：這裡不再有任何寫死的句子。
// label 是按鈕上的短字、question 是點下去帶進輸入框的完整問句，兩件事分開。

export interface QuickQaSuggestion {
  quickQaId: string
  label: string
  question: string
}

// 伺服器已經篩掉停用的、截斷成前六則並依 order 排好，這裡照收不再加工。
// 🔴 取不到就回空陣列讓那一區消失：建議按鈕是錦上添花，不該讓首屏卡在它身上。
export const fetchQuickQas = async (): Promise<QuickQaSuggestion[]> => {
  const res = await fetch('/api/ai/quick-qas').catch(() => null)
  if (!res?.ok) return []
  const body = await res.json().catch(() => null) as { quickQas?: QuickQaSuggestion[] } | null
  return body?.quickQas ?? []
}
